export const VoucherModalKey = "Voucher-ModalKey";
